var exports = {
  "kL": "x127c5a35--1c7ed4--container",
  "pU": "x127c5a35--1c7ed4--iframe",
  "VN": "x127c5a35--1c7ed4--close",
  "u1": "x127c5a35--1c7ed4--spinner",
};

module.exports = exports;
